<template>
  <div id="GuestInfoFrame">
    <div
      v-for="(item , index) in data"
      :key="item.guestId"
      class="transitionDiv"
    >
      <transition
        v-if="index < 4"
        name="el-zoom-in-bottom"
      >
        <div
          v-if="dialogVisible"
          class="guestInfoFrame_main"
        >
          <div
            v-if="!item.collapse"
            class="tabletNote"
          >
            {{ item.guestName }}
          </div>
          <div class="title">
            接收到一筆現場訪客登記資料
          </div>
          <div
            v-if="!item.collapse"
            class="subtitleDiv"
          >
            <div class="subtitle">
              請確認是否為現場登記的訪客
            </div>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="checkGuestArrive(index,item.guestId)"
            >
              確認訪客抵達
            </el-button>
          </div>
          <div class="btnGroup">
            <div
              class="collapseBtn"
              @click="collapseDiv(item)"
            >
              <i
                v-if="item.collapse"
                class="icon-toggle-up"
                aria-hidden="true"
              />
              <i
                v-else
                class="icon-toggle-down"
                aria-hidden="true"
              />
            </div>
            <div
              class="cancelBtn"
              @click="closeItem(index)"
            >
              <i
                class="icon-cancel"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { createBroadcastChannel } from '@/js/utils/broadcastChannelHelper'
export default {
  data () {
    return {
      allData: [], // 紀錄localstorge array
      data: [], // 紀錄顯示array
      collapse: false,
      dialogVisible: true,
      getDataTimer: null,
      guestInfoFrameKey: 0,
      guestChannel: null // 廣播頻道
    }
  },
  mounted () {
    // 處理廣播頻道的訊息
    const handleGuestMessage = (event) => {
      const { type, data } = event.data || {}
      switch (type) {
      case 'deleteItem':
        if (data.id) {
          const findItemIndex = this.data.findIndex(item => item.guestId === data.id)
          if (findItemIndex !== -1) {
            this.closeItem(findItemIndex)
          }
        }
        break
      case 'editItem':
        if (data.id && data.guestName) {
          try {
            const arrivedGuest = JSON.parse(localStorage.arrivedGuest)
            const findGuest = arrivedGuest.find(item => item.guestId === data.id)
            if (findGuest) {
              findGuest.guestName = data.guestName
            }
            localStorage.setItem('arrivedGuest', JSON.stringify(arrivedGuest))
            this.show()
          } catch (error) {
            console.log(error)
          }
        }
        break
      }
    }
    // 設定廣播頻道
    this.guestChannel = createBroadcastChannel('guest', handleGuestMessage)

    // 收推播
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', event => {
        console.log(event.data)
        if (event.data.GuestId) {
          this.dialogVisible = true
          const obj = {
            guestId: event.data.GuestId,
            communityName: event.data.CommunityName,
            guestName: event.data.GuestName
          }
          const data = localStorage.getItem('arrivedGuest') ? JSON.parse(localStorage.arrivedGuest) : []
          let error = false
          data.forEach(item => {
            if (item.guestId === obj.guestId) { error = true }
          })
          if (!error) {
            data.push(obj)
            /**
             * 廣播訊息: 新訪客預約
             * 1. 因收到推播時如果立即重整頁面無法顯示此筆資料，所以需要有延遲時間
             */
            this.guestChannel.postMessage({ type: 'newReservation', data: { delay: 1500 } })
          }
          localStorage.setItem('arrivedGuest', JSON.stringify(data))
          this.show()
        }
      })
    }
    if (window.location.href.indexOf('login') !== -1 && localStorage.getItem('arrivedGuest') && JSON.parse(localStorage.arrivedGuest).length > 0) { this.show() }
    // 監聽localstorage有變化時，全部瀏覽器分頁都要更新
    this.getDataTimer = setInterval(() => {
      if (localStorage.getItem('arrivedGuest') && JSON.parse(localStorage.arrivedGuest).length > 0) {
        if (this.data.length !== JSON.parse(localStorage.arrivedGuest).length) { this.show() }
      }
      if (!this.$isServiceEnabled(17) || this.$route.path.indexOf('login') !== -1) { clearInterval(this.getDataTimer) }
    }, 1000)
  },
  methods: {
    // 處理顯示array
    show () {
      console.log('show')
      this.allData = JSON.parse(localStorage.arrivedGuest)
      if (this.allData.length > 0) {
        this.data = []
        const CommunityName = JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName
        this.allData.forEach(item => {
          if (item.communityName === CommunityName) {
            const obj = { ...item }
            obj.collapse = false
            this.data.push(obj)
          }
        })
        if (this.data.length > 0) { this.dialogVisible = true }
      }
    },
    // click [確認訪客抵達]
    checkGuestArrive (index, guestId) {
      if (process.env.NODE_ENV === 'development') { window.open(`${window.location.origin}/PlusGuestReservation/${guestId}`) } else { window.open(`${window.location.origin}/mgmt/PlusGuestReservation/${guestId}`) }
      this.closeItem(index)
    },
    // 關閉
    closeItem (index) {
      this.allData.splice(index, 1)
      this.data.splice(index, 1)
      localStorage.setItem('arrivedGuest', JSON.stringify(this.allData))
      if (this.allData.length === 0) {
        this.dialogVisible = false
      }
    },
    collapseDiv (item) {
      console.log('collapseDiv')
      item.collapse = !item.collapse
    }
  }
}
</script>

<style lang="sass" scoped>
#GuestInfoFrame
  z-index: 1999
  position: fixed
  right: 0
  bottom: 0
  display: flex
  flex-direction: column-reverse
  .transitionDiv
    flex: 1
    .guestInfoFrame_main
      position: relative
      width: 400px
      background-color: $white
      font-size: 25px
      border-top-left-radius: 15px
      padding: 20px 8px 20px 30px
      box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.3)
      box-sizing: border-box
      transition: all 0.4s ease-in-out
      margin-top: 5px
      &.collapse
        padding-left: 30px
        padding-top: 28px
      .tabletNote
        color: $warnColor
        font-size: 16px
        margin-bottom: 10px
      .title
        color: #464646
        font-size: 18px
        font-weight: 600
      .subtitleDiv
        display: flex
        .el-button
          position: relative
          top: 10px
      .subtitle
        color: #808080
        font-size: 16px
        margin-top: 15px
        margin-right: 30px
      .btnGroup
        width: 70px
        height: 30px
        position: absolute
        right: 15px
        top: 8px
        cursor: pointer
        display: flex
        text-align: center
        .collapseBtn
          flex: 4
        .cancelBtn
          flex: 3
          width: 30px
          height: 30px
          background-color: #EAEAEA
          border-radius: 45px
        i
          font-size: 15px
</style>
